import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    hour: {
        id: "hour",
    },
    minute: {
        id: "minute",
    },
});

export default messages;
